import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LineStateEnum } from 'src/app/samwebDescription/samwin/LineStateEnum';
import { CallRecordingState } from 'src/generated/signalR/call-recording-state';
import { SamwinCallInfoRemoteDto } from '../../../../generated/signalR/samwin-call-info-remote-dto';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from '../../utility/IBrickInstanceTargetingAction';
import { DialTarget } from '../next-dial-target/next-dial-target.state';

export class DialpadKeyPressedAction implements IBrickInstanceTargetingAction {
   public static readonly type = '[ClientPhone] Dialpad key pressed';

   constructor(public keyValue: string, public brickInstanceId) {}
}

export class SendDtmfToneAction {
   public static readonly type = '[ClientPhone] Send DTMF tone';

   constructor(public pressedDialpadKey: string) {}
}

export class SendDtmfToneInternalAction {
   public static readonly type = '[ClientPhone] Send DTMF tone (internal)';

   constructor() {}
}

export class DialpadNumberChangedAction implements IBrickInstanceTargetingAction {
   public static readonly type = '[ClientPhone] Dialpad number changed';

   constructor(public dialpadNumber: string, public brickInstanceId, public processInputForDtmf: boolean = false) {}
}

export class AcceptOrStartCallAction {
   public static readonly type = '[ClientPhone] Accept or Start Call';

   constructor(public userDecision?: 'dial' | 'accept') {}
}

export class AcceptRingingCallAction {
   public static readonly type = '[ClientPhone] Accept Ringing Call';
}

export class AcceptCallFromCallList {
   public static readonly type = '[ClientPhone] Accept Call From Call List';

   constructor(public call: SamwinCallInfoRemoteDto, public position: number) {}
}

export class AcceptSpecificCallAction {
   public static readonly type = '[ClientPhone] Accept Specific Call';

   constructor(public callId: number) {}
}

export class StartNewCallAction {
   public static readonly type = '[ClientPhone] Start Call';

   constructor(public numberToDial: string | DialTarget, public skillId?: number) {}
}

export class InitiateNewCallAction {
   public static readonly type = '[ClientPhone] Initiate Call';

   constructor(public numberToDial: string | DialTarget, public skillId: number) {}
}

export class InitiateNewConsultCallAction {
   public static readonly type = '[ClientPhone] Initiate Consult Call';

   constructor(public numberToDial: string | DialTarget) {}
}

export class EndCallAction {
   public static readonly type = '[ClientPhone] End Call';
}

export class CompleteTransferAction {
   public static readonly type = '[ClientPhone] Complete Transfer';
}

export class DisconnectLineA {
   public static readonly type = '[ClientPhone] Disconnect Line A';
}

export class DisconnectLineB {
   public static readonly type = '[ClientPhone] Disconnect Line B';
}

export class ReassignCall {
   public static readonly type = '[ClientPhone] Reassign Call';
}

export class DropCall {
   public static readonly type = '[ClientPhone] Drop Call';

   constructor(public callIdToDrop: number) {}
}

export class ParkCallAgent {
   public static readonly type = '[ClientPhone] Park Call On Agent';
}

export class ParkCallSkill {
   public static readonly type = '[ClientPhone] Park Call On Skill';
}

export class StartConference {
   public static readonly type = '[ClientPhone] Start Conference';
}

export class ToggleHoldLineA {
   public static readonly type = '[ClientPhone] Toggle hold line A';
}

export class ToggleHoldLineB {
   public static readonly type = '[ClientPhone] Toggle hold line B';
}

export class ToggleManualCallRecording {
   public static readonly type = '[ClientPhone] Toggle Manual Call Recording';

   constructor() {}
}

export class MarkMaliciousCall {
   public static readonly type = '[ClientPhone] Mark Malicious Call';

   constructor(public callId: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class ReQueueCall {
   public static readonly type = '[ClientPhone] ReQueue Call';

   constructor(public callId: number, public queueId: number) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class ExecuteIvr {
   public static readonly type = '[ClientPhone] Execute IVR';

   constructor(public callId: number, public ivrId: number) {}
}

export class SwitchHoldLines {
   public static readonly type = '[ClientPhone] Switch hold lines';

   constructor() {}
}

export class PhoneStartedRinging {
   public static readonly type = '[ClientPhone] Phone Started Ringing';

   constructor() {}
}

export class ChangeRequestUserDecision {
   public static readonly type = '[ClientPhone] Changing Request User Decision';

   constructor(public newValue: boolean) {}
}

export class BargeInListen {
   public static readonly type = '[ClientPhone] Requesting BargeIn Listen';

   constructor(public userId: number = null) {}
}

export class BargeInWhisper {
   public static readonly type = '[ClientPhone] Requesting BargeIn Whisper';

   constructor(public userId: number = null) {}
}

export class BargeInConference {
   public static readonly type = '[ClientPhone] Requesting BargeIn Conference';

   constructor(public userId: number = null) {}
}

export class SourceLineConnected {
   public static readonly type = '[ClientPhone] Source Line is Connected';

   constructor(public lineStateEnum: LineStateEnum) {}
}

export class CallRecordingStateUpdatedByServer {
   public static readonly type = '[ClientPhone] Call Recording State Updated';

   constructor(public callId: number, public recordingState: CallRecordingState) {}
}
